/* eslint-disable react/prop-types */
/**
 * UserPreferencesProvider
 * Contain most logic handing with Omnitech Api
 */

import _ from 'lodash'
import React from 'react'
import { createPersistedState } from '../../cache'
import UserPreferencesContext from './user-preferences-context'
const useUserPreferencesState = createPersistedState('userPreferences')

export default function UserPreferencesProvider({ children }) {

  const [userPreferences, setUserPreferences] = useUserPreferencesState({})

  const handleSetUserPreferences = (...args) => {
    let newData = {}
    if (args.length === 2) {
      newData = { [args[0]]: args[1] }
    } else if (_.isArray(args[0]) && _.size(args[0]) === 2) {
      newData = { [args[0][0]]: args[0][1] }
    } else if (_.isObject(args[0])) {
      newData = args[0]
    }
    setUserPreferences((orig) => ({ ...orig, ...newData }))
  }

  const contextValue = {
    userPreferences,
    setUserPreferences: handleSetUserPreferences,
  }
  return (
    <UserPreferencesContext.Provider value={contextValue}>
      {children}
    </UserPreferencesContext.Provider>
  )
}
